import React, { useState } from 'react';
import { BrowserRouter, Routes, Route , Link, useNavigate} from 'react-router-dom';
import './PublicNavbar.css';


export default function Navbar({ actions = [], onActionClick }) {
  return (
    <div className="Navbar-container">
      <div className="Navbar-menu">
        {actions.map((action, index) => (
          <div
            key={index}
            className="Navbar-button"
            onClick={() => onActionClick && onActionClick(action.id || action)}
          >
            {typeof action === "string" ? action : action.label}
          </div>
        ))}
      </div>
      <div className="Navbar-linhabg1"></div>
    </div>
  );
}